import {Controller} from '@hotwired/stimulus';
import throttle from 'lodash/throttle';
import device from '../../js/device';

/* stimulusFetch: 'lazy' */
export default class extends Controller {

    static targets = ['bar', 'body'];

    connect() {

        if (device.getType() === 'desktop') {
            return;
        }


        this.scroll = throttle(this.scroll.bind(this), 100)
        window.addEventListener('scroll', this.scroll, {passive: true})
    }

    scroll() {
        const percentage = this._percentageSeen()

        if (percentage > 0) {
            this.barTarget.classList.add('!h-1.5')
        } else {
            this.barTarget.classList.remove('!h-1.5')
        }

        this.barTarget.firstElementChild.style.width = `${percentage}%`
    }

    _percentageSeen() {
        // Get the relevant measurements and positions
        const viewportHeight = window.innerHeight;
        const scrollTop = window.scrollY;
        const elementOffsetTop = this.bodyTarget.offsetTop;
        const elementHeight = this.bodyTarget.offsetHeight;

        // Calculate percentage of the element that's been seen
        const distance = scrollTop + viewportHeight - elementOffsetTop;
        const percentage = Math.round(distance / (elementHeight / 100));

        // Restrict the range to between 0 and 100
        return Math.min(100, Math.max(0, percentage));
    };

}